import { coursesApi } from "api/courses/coursesApi";
import { Switch } from "components/atoms/PaziaSwitch/Switch";
import { useState } from "react";
import { useToaster } from "utils";

interface CourseRegistrationSettingsProps {
  courseId: number;
  registrationsClosed: boolean | null;
  allowRegistrationAfterStart: boolean;
  invalidate: () => Promise<unknown>;
  className?: string;
}

export const CourseRegistrationSettings = ({
  courseId,
  registrationsClosed,
  allowRegistrationAfterStart,
  invalidate,
  className,
}: CourseRegistrationSettingsProps) => {
  const { showSuccess, showError } = useToaster();
  const [saving, setSaving] = useState(false);

  const save = async (next: { registrationsClosed: boolean | null; allowRegistrationAfterStart: boolean }) => {
    setSaving(true);
    try {
      await coursesApi.updateRegistrationSettings(courseId, next);
      await invalidate();
      showSuccess("Zaktualizowano ustawienia zapisów");
    } catch {
      showError("Nie udało się zapisać zmian");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`flex flex-col gap-3 ${className ?? ""}`}>
      <div className="text-sm font-semibold uppercase tracking-wide text-slate-700 dark:text-slate-300">
        Zapisy
      </div>
      <Switch
        name="registrationsClosed"
        label="Zamknij zapisy"
        checked={registrationsClosed === true}
        disabled={saving}
        onBlur={() => undefined}
        onChange={(e) => save({ registrationsClosed: e.target.checked, allowRegistrationAfterStart })}
      />
      <Switch
        name="allowRegistrationAfterStart"
        label="Pozwól zapisać się po rozpoczęciu kursu"
        checked={allowRegistrationAfterStart}
        disabled={saving || registrationsClosed === true}
        onBlur={() => undefined}
        onChange={(e) => save({ registrationsClosed, allowRegistrationAfterStart: e.target.checked })}
      />
      <div className="text-xs text-slate-500 dark:text-slate-400">
        Ręczne zamknięcie zawsze wygrywa. Override pozwala zapisać się aż do daty zakończenia kursu.
      </div>
    </div>
  );
};
